// Глобальный флаг режима изучения (Этап 46.13).
// Активируется кнопкой «?» на любом экране. В этом режиме:
//   - Затемняется весь интерфейс (overlay).
//   - Элементы с data-tt подсвечиваются циан-обводкой и кликабельны.
//   - Тап по элементу → попап с описанием из tooltips.ts.
//   - Обычные действия экрана (навигация, покупка и т.п.) НЕ срабатывают.
//   - Снова «?» → выход из режима.

import { create } from 'zustand';

interface StudyState {
  active: boolean;
  openTtKey: string | null;
  toggle: () => void;
  enable: () => void;
  disable: () => void;
  openTooltip: (key: string) => void;
  closeTooltip: () => void;
}

export const useStudyMode = create<StudyState>((set) => ({
  active: false,
  openTtKey: null,
  toggle: () =>
    set(s => {
      const next = !s.active;
      document.body.classList.toggle('study-mode', next);
      return { active: next, openTtKey: null };
    }),
  enable: () =>
    set(() => {
      document.body.classList.add('study-mode');
      return { active: true };
    }),
  disable: () =>
    set(() => {
      document.body.classList.remove('study-mode');
      return { active: false, openTtKey: null };
    }),
  openTooltip: (key) => set({ openTtKey: key }),
  closeTooltip: () => set({ openTtKey: null })
}));
